import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button, Form, FormControl } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import {
  useAddCategoryMutation,
  useCategoryCountQuery,
} from "../../services/categoryApi";

import { v4 as uuidv4 } from "uuid";

import SelectCategoryGroup from "../Common/CustomSelect/selectCategoryGroup";
import SelectMC from "../Common/CustomSelect/selectMC";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import PackageModal from "../Common/Modal/PackageModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import { apiUniqueErrHandle } from "../Utility/Utility";
import "./Category.css";
import { useSelector } from "react-redux";
import { group } from "console";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";


const AddSubCategory = () => {
  const auth = signInUser();
  const lang = useSelector((state:any) => state.languageReducer);
  //@ts-ignore

  const { aamarId } = auth;
  // console.log("aamarId", aamarId);
  let navigate = useNavigate();
  const [addCategory] = useAddCategoryMutation();
  const { data: countData } = useCategoryCountQuery({ aamarId });
  const [supplierCode, setSupplierCode] = useState<string>(""); // Initializing with an empty string

  const [mc, setMc] = useState({});
  const [mcNew, setMcNew] = useState("");
  const [mg, setMg] = useState<any>(null);
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => setModalVisible(false);
  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});
  // console.log(mc)
  // console.log("Count DATA", countData);
  //@ts-ignore
  // console.log("categoryLimited", auth?.package?.categoryLimited);
 const checkCodeInAPI = async (code) => {
   try {
     const response = await axios.get(
       `${BASE_URL}category/unique/${code}/${aamarId}`,
       {
         params: { code },
       }
     );
     console.log(response.data.exists);
     return response.data.exists;
   } catch (error) {
     console.error("Error checking code in API:", error);
     return false; // Default to not found in case of an error
   }
 };
  const supplierUniqueSixDigitCode = async () => {
      let numericCode;
      do {
        const uuid = uuidv4();
        numericCode = parseInt(uuid.split("-")[0], 16) % 1000000;
        numericCode = String(numericCode).padStart(6, "0");
      } while (await checkCodeInAPI(numericCode));
  
      setSupplierCode(numericCode);
      return numericCode;
    };
  
    useEffect(() => {
      supplierUniqueSixDigitCode();
    }, []);
  const handleAddCategory = async (data: any) => {
    const generatedCode = await supplierUniqueSixDigitCode();

    //@ts-ignore
    if (countData >= auth?.package?.categoryLimited) {
      setModalVisible(true);
      return;
    } else {
      // setLoader(true)
      const newData = {
        ...data,
        mc: mcNew || null,
        aamarId: aamarId,
        group: (typeof mg === "object" && mg?._id) ? mg._id : (mg || null),
        // mcId: generatedCode,
        code: generatedCode,
      };
      console.log("newData", newData);
      // console.log(data);
      // console.log(mcNew);
      try {
        const response: any = await addCategory(newData);
        console.log("API Response:", response);

        if (response?.error) {
          console.log("Error Details:", response?.error);
          apiUniqueErrHandle(response);
          notify("Code must be unique", "error");
        } else {
          reset({
            name: "",
            code: "",
            mc: null,
            mcId: "",
            photo: "",
            group: "",
            description: "",
            status: "active",
          });
          navigate("/subcategory");
        }
      } catch (err) {
        console.error("Error while adding category:", err);
        notify("Code must be unique", "error");
      } finally {
        setLoader(false);
      }
    }
  };

  const handleOnchange = (e: any) => {
    // console.log(e.label.split(" - "))

    if (e && e.option) {
      setMc(e.option);
      setMcNew(e.option);
      // console.log(e.option);
      let mCat = e.label.split(" - ");
      reset({
        mc: e.option,
        mcId: mCat[1],
      });
    }
  };

  const handleOnchangeGroup = (e: any) => {
    if (e && e.option) {
      // console.log(e.option);
      setMg(e.option);
      reset({
        group: e.option,
      });
    }
  };
  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.addNewCategory}></Header>
            <div className="row mt-4">
              <div className="col-md-6 offset-md-3">
                <Form onSubmit={handleSubmit(handleAddCategory)}>
                  <Form.Group className="mb-3" controlId="formBasicName">
                    <Form.Label>
                      Sub Category Name <span className="text-red">*</span>
                    </Form.Label>
                    <FormControl
                      {...register("name", {
                        required: "*Category Name is Required", // Custom error message
                      })}
                      type="text"
                      placeholder="Category Name"
                    />
                    {errors.name && notify(errors.name.message, "error")}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicName">
                    <Form.Label>Category</Form.Label>
                    {/* <Form.Control {...register("mc", { required: true })} type="text" placeholder="Enter email" /> */}
                    <SelectMC
                      mc={mc}
                      handleOnchange={(e: any) => handleOnchange(e)}
                    ></SelectMC>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      Category Description<span className="text-red">*</span>
                    </Form.Label>
                    <textarea
                      className="form-control"
                      placeholder="Write a description..."
                      {...register("description", {
                        required: "*Category Description is Required", // Custom error message
                      })}
                    />
                    {errors.description &&
                      notify(errors.description.message, "error")}
                    <Form.Text className="text-muted">
                      We'll never share your email with anyone else.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPhone">
                    <Form.Label>Group</Form.Label>
                    <SelectCategoryGroup
                      mg={mg}
                      handleOnchange={setMg}
                    ></SelectCategoryGroup>
                    <Form.Text className="text-muted">
                      We'll never share your email with anyone else.
                    </Form.Text>
                  </Form.Group>

                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group
                        className="mb-3"
                        controlId="formBasicPassword"
                      >
                        <Form.Label>
                          Code<span className="text-red">*</span>
                        </Form.Label>
                        <Form.Control
                          {...register("code", {
                            required: "*Code is Required",
                          })}
                          type="text"
                          name="code"
                          placeholder="code"
                          value={supplierCode}
                        />{" "}
                        {errors.code && notify(errors.code.message, "error")}
                        <Form.Text className="text-muted">
                          We'll never share your email with anyone else.
                        </Form.Text>
                      </Form.Group>
                    </div>

                    <div className="col-md-6">
                      <Form.Group className="mb-3" controlId="formBasicStatus">
                        <Form.Label>Status</Form.Label>
                        <Form.Select {...register("status")}>
                          <option value="active">Active</option>
                          <option value="suspend">Suspend</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </div>

                  <Link
                    to="/subcategory"
                    className="btn btn-outline-dark float-center me-2"
                  >
                    <Icons.X size={20}></Icons.X> Cancel
                  </Link>

                  <Button variant="dark" className="float-center" type="submit">
                    <Icons.PlusOutline size={20}></Icons.PlusOutline> Add
                    Category
                  </Button>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Package Info Modal */}
      <PackageModal show={modalVisible} handleClose={closeModal} />{" "}
    </div>
  );
};

export default AddSubCategory;
